module.exports = __webpack_public_path__ + "img/myspace.a3f658ab.png";